import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Lightweight collapsible card. Defaults to COLLAPSED to keep the dashboard clean.
 * Used for: Identity DNA Signature Proof, SHA-512 / MSN-CLIQ ROOT, and the
 * Tech-Lead / Credits attribution panel.
 *
 * @prop {string} title         — main header text
 * @prop {string} badge         — optional small badge text (right side)
 * @prop {ReactNode} icon       — optional left-side icon
 * @prop {boolean} defaultOpen  — default false (collapsed)
 * @prop {string} testid        — root data-testid prefix
 */
export default function CollapsibleCard({ title, badge, icon, defaultOpen = false, testid = 'collapsible', children }) {
  const [open, setOpen] = useState(!!defaultOpen);
  return (
    <div className="collapsible-card" data-testid={testid}>
      <button
        type="button"
        className="collapsible-card-header"
        aria-expanded={open}
        onClick={() => setOpen(o => !o)}
        data-testid={`${testid}-toggle`}
        style={{ width: '100%', border: 'none', textAlign: 'left' }}
      >
        <span className="collapsible-card-title">
          {icon}
          {title}
          {badge && (
            <span
              style={{
                marginLeft: 6, padding: '2px 8px', fontSize: 9, fontWeight: 700,
                color: 'var(--brand-blue, #0078D4)',
                background: 'rgba(0,120,212,0.08)',
                borderRadius: 999, letterSpacing: '0.05em', textTransform: 'uppercase'
              }}
            >{badge}</span>
          )}
        </span>
        <ChevronDown size={14} className="collapsible-card-chevron" />
      </button>
      {open && (
        <div className="collapsible-card-body" data-testid={`${testid}-body`}>
          {children}
        </div>
      )}
    </div>
  );
}
